/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.RailzBusinessAccountResponse | undefined,
  (params: vp.PortalUser) => void,
  () => void,
  (params: vp.PortalUser) => Promise<vp.RailzBusinessAccountResponse>,
];

function useFetchRailzBusinessAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.PortalUser>();
  const [response, setResponse] = useState<vp.RailzBusinessAccountResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.PortalUser) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchRailzBusinessAccount(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.PortalUser) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    (requestParams: vp.PortalUser) => api.fetchRailzBusinessAccount(requestParams, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchRailzBusinessAccount);
